import Vue from 'vue'
import { makeQueryStringDync, errorServeiceHandler, makeQueryFormDataDyn } from '../helper'

const state = {
   regSubData: undefined,
};

const getters = {
    getRegSubData: (state) => {
        return state.regSubData;
    },
};

const mutations = {
    setRegSubData: (state, data) => {
        state.regSubData = data;
    },
};

const actions = {
    actGetlogin: (context, payload) => {
        return new Promise( (resolve, reject) => {
            if (!payload) {
                reject({error: "payload not found"});
            }
            let queryStr = ''
            queryStr = makeQueryStringDync(payload);

           fetch(context.getters.baseUrl + '/lco/v1/login.php' + queryStr, {
            method: 'GET'
           })
           .then(errorServeiceHandler)
           .then((response) => {
               return response.json()
            }).then((data) => {
                resolve(data)
            }).catch((error) => {

                reject(error);
            });
        });
    },

    actregionRegister:(context,payload) => {
        return new Promise( (resolve, reject) => {
        fetch('https://iid.googleapis.com/iid/v1/'+payload.token+'/rel/topics/'+payload.region, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'key=AAAAxyanXP4:APA91bGKciVJii-BYh1OVNieNJ-JiqKI0S3btogVrqRxdxExZ0QmQzX7Yy1Nm_T_XrNcG_vKvk1dpNYhtKss4_FQew28htVCXBYna2qZ3NoFI0nQ8RES4xJTxfZa_t6IDqfDKDHc__VJ'
                }
            })
            .then((response) => {
                return response.json()
            }).then((data) => {
                resolve(data)
            }).catch((error) => {
                if (context.getters.getMode == "development") {
                    resolve({"lcoid":"h7juP6Xn","lconame":"Thomas John","frcode":"FR5125","frcan":"20893551","city":null,"region":"MUM","country":"IN","status":"ACTIVE","mobileno":"7981891902","contactname":"","email":"harsha.arukala@gamil.com","amount":"1675.42","currency":"INR","panno":"ACCPE3456","dpid":"0roEv0l1","connections":"0","smstype":"SMS1","quiz_complete":"NO","lcoagreementtype":"NO","lcoportalnumber":"THREE","payment":"YES","NCF":"ON"})
                }
                reject(error);
            })
        });
    },
    actGetSubuserlogin: (context, payload) => {
        return new Promise( (resolve, reject) => {
            if (!payload) {
                reject({error: "payload not found"});
            }
            let queryStr = ''
            queryStr = makeQueryStringDync(payload);

           fetch(context.getters.baseUrl + '/lco/v1/subuser/login' + queryStr, {
            method: 'GET'
           })
           .then(errorServeiceHandler)
           .then((response) => {
               return response.json()
            }).then((data) => {
                resolve(data)
            }).catch((error) => {
                reject(error);
            });
        });
    },
    actGetfrcan: (context, payload) => {
        return new Promise( (resolve, reject) => {
            if (!payload) {
                reject({error: "payload not found"});
            }
            let queryStr = ''
            queryStr = makeQueryStringDync(payload);

           fetch(context.getters.baseUrl + '/lco/v1/lco/frcan' + queryStr, {
            method: 'GET'
           })
           .then(errorServeiceHandler)
           .then((response) => {
                return response.json()
            }).then((data) => {
                if (context.getters.getMode == "development") {
                    resolve({"success":"20893551","type":"MOCA","user":"LCO"})
                }
                else {
                    resolve(data)
                }
                
            }).catch((error) => {
                if (context.getters.getMode == "development") {
                    resolve({"success":"20893551","type":"MOCA","user":"LCO"})
                }
                reject(error);
            });
        });
    },
    actGetHeadend: (context, payload) => {
        return new Promise( (resolve, reject) => {
            if (!payload) {
                reject({error: "payload not found"});
            }
            let queryStr = ''
            queryStr = makeQueryStringDync(payload);

           fetch(context.getters.baseUrl + '/lco/v1/lco/headend' + queryStr, {
            method: 'GET'
           })
           .then(errorServeiceHandler)
           .then((response) => {
                return response.json()
            }).then((data) => {
                if (context.getters.getMode == "development") {
                    resolve({"headendid":"ADW","headendname":"ANDHERI-W"})
                }
                else {
                    resolve(data) 
                }
                
            }).catch((error) => {
                if (context.getters.getMode == "development") {
                    resolve({"headendid":"ADW","headendname":"ANDHERI-W"})
                }
                reject(error);
            });
        });
    },
    actGetEmp: (context, payload) => {
        return new Promise( (resolve, reject) => {
            if (!payload) {
                reject({error: "payload not found"});
            }
            let queryStr = ''
            queryStr = makeQueryStringDync(payload);

           fetch(context.getters.baseUrl + '/lco/v1/lco/emp' + queryStr, {
            method: 'GET'
           })
           .then(errorServeiceHandler)
           .then((response) => {
                return response.json()
            }).then((data) => {
                if (context.getters.getMode == "development") {
                    resolve([{"employee":"AVINASH TATE","employeename":"AVINASH TATE"}])
                }
                else {
                    resolve(data)
                }
            }).catch((error) => {
                if (context.getters.getMode == "development") {
                    resolve([{"employee":"AVINASH TATE","employeename":"AVINASH TATE"}])
                }
                reject(error);
            });
        });
    },
    actRegister: (context, payload) => {
        return new Promise( (resolve, reject) => {
            if (!payload) {
                reject({error: "payload not found"});
            }
            let data = makeQueryFormDataDyn(payload);
           fetch(context.getters.baseUrl + '/lco/v1/account.php', {
            method: 'POST',
            body: data
           })
           .then(errorServeiceHandler)
           .then((response) => {
               return response.json()
            }).then((data) => {
                resolve(data)
            }).catch((error) => {
                reject(error);
            });
        });
    },
    actGetForgetPassword: (context, payload) => {
        return new Promise( (resolve, reject) => {
            if (!payload) {
                reject({error: "payload not found"});
            }
            let queryStr = ''
            queryStr = makeQueryStringDync(payload);
    
           fetch(context.getters.baseUrl + '/lco/v1/passwordreset.php' + queryStr, {
            method: 'GET'
           })
           .then(errorServeiceHandler)
           .then((response) => {
                return response.json()
            }).then((data) => {
                resolve(data)
            }).catch((error) => {
                reject(error);
            });
        });
    },
    actGetAdvt: (context, payload) => {
        return new Promise( (resolve, reject) => {
            if (!payload) {
                reject({error: "payload not found"});
            }
            // let dataObj = {};
            let queryStr = ''
            // dataObj = {
            //     'adtype' : payload.adtype
            // }
            queryStr = makeQueryStringDync(payload);
            fetch(context.getters.baseUrl + '/lco/v1/banner' + queryStr, {
            method: 'GET'
           })
           .then(errorServeiceHandler)
           .then((response) => {
                return response.json()
            }).then((data) => {
                if (context.getters.getMode == "development") {
                  resolve([ {
                    "promoadsid": "4",
                    "filename": "IlXPqBPk.jpg",
                    "adtype": "AD",
                    "weight": "1",
                    "adstatus": "ACTIVE",
                    "created": "2019-10-15 11:05:37",
                    "url": "https://s3.ap-south-1.amazonaws.com/com.kyc.dpcollection.incablenet.mum/images/promo/IlXPqBPk.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAI4W3T6IPZZE7ILKA%2F20191018%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20191018T073530Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=71ec1f05f73bba83a2838784913c2c40841df55c3ac276af9472f0dab24bb27c"
                },
                {
                    "promoadsid": "3",
                    "filename": "IlXPqBPk.jpg",
                    "adtype": "AD",
                    "weight": "1",
                    "adstatus": "ACTIVE",
                    "created": "2019-10-15 10:58:40",
                    "url": "https://s3.ap-south-1.amazonaws.com/com.kyc.dpcollection.incablenet.mum/images/promo/IlXPqBPk.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAI4W3T6IPZZE7ILKA%2F20191018%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20191018T073530Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=71ec1f05f73bba83a2838784913c2c40841df55c3ac276af9472f0dab24bb27c"
                }]);
                }
                else {
                    resolve(data)
                }
            }).catch((error) => {
                if (context.getters.getMode == "development") {

                    resolve([ {
                        "promoadsid": "4",
                        "filename": "IlXPqBPk.jpg",
                        "adtype": "AD",
                        "weight": "1",
                        "adstatus": "ACTIVE",
                        "created": "2019-10-15 11:05:37",
                        "url": "https://s3.ap-south-1.amazonaws.com/com.kyc.dpcollection.incablenet.mum/images/promo/IlXPqBPk.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAI4W3T6IPZZE7ILKA%2F20191018%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20191018T073530Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=71ec1f05f73bba83a2838784913c2c40841df55c3ac276af9472f0dab24bb27c"
                    },
                    {
                        "promoadsid": "3",
                        "filename": "IlXPqBPk.jpg",
                        "adtype": "AD",
                        "weight": "1",
                        "adstatus": "ACTIVE",
                        "created": "2019-10-15 10:58:40",
                        "url": "https://s3.ap-south-1.amazonaws.com/com.kyc.dpcollection.incablenet.mum/images/promo/IlXPqBPk.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAI4W3T6IPZZE7ILKA%2F20191018%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20191018T073530Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=71ec1f05f73bba83a2838784913c2c40841df55c3ac276af9472f0dab24bb27c"
                    }]);
                }
                reject(error);
            });
        });
    },
    setUserAgreement: (context, payload) => {
        return new Promise((resolve, reject) => {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            let data = makeQueryFormDataDyn(payload);
            fetch(context.getters.baseUrl + '/lco/v1/lco/lcoagreement', {
                method: 'POST',
                body: data
            })
            .then(errorServeiceHandler)
            .then((response) => {
                return response.json()
            }).then((data) => {
                resolve(data)
            }).catch((error) => {
                reject(error);
            });
        });
    },
    checkPortalMaintenance: (context) => {
        return new Promise((resolve, reject) => {
          fetch(context.getters.baseUrl + "/lco/v1/lco/maintenance", {
            method: "GET",
          })
            .then(errorServeiceHandler)
            .then(response => {
              return response.json();
            })
            .then(data => {
              if (context.getters.getMode == "development") {
                resolve({
                  "maintenance": "OFF",
                  "header": "Portal Maintenance",
                  "image": "https://png.pngtree.com/thumb_back/fw800/background/20190813/pngtree-happy-ganesh-chaturthi-vector-banner-background-design-with-golden-color-gradient-image_299194.jpg",
                  "content": "We clearly live in unprecedented times as Covid-19 is changing the world around us. Our thoughts and prayers are with everyone who is impacted. Now more than ever, we must come together as a community. With the uncertainty of the physical event happening this year, we decided to launch the first virtual event in response to the coronavirus lockdown. We would like to welcome you to Neotia Arts Trust’s new chapter — The India Story Continues… We will be hosting a Live web series of conversations, workshops, and performances from artists, designers, influencers, and many from all over India. Live events will be broadcasted every Saturday through the months of August, September, and October. It is complimentary and open to all and will be available on all our platforms — Youtube, Facebook, & our website. We are excited to continue creating, sharing, and learning with you all.",
                  "style": ""
                })
                return
              } else {
                resolve(data);
              }
            })
            .catch(error => {
                if (context.getters.getMode == "development") {
                    resolve({
                      "maintenance": "OFF",
                      "redirect": "https://lcoportalv2.incablenet.net/",
                      "header": "Portal Maintenance",
                      "image": "https://png.pngtree.com/thumb_back/fw800/background/20190813/pngtree-happy-ganesh-chaturthi-vector-banner-background-design-with-golden-color-gradient-image_299194.jpg",
                      "content": "We clearly live in unprecedented times as Covid-19 is changing the world around us. Our thoughts and prayers are with everyone who is impacted. Now more than ever, we must come together as a community. With the uncertainty of the physical event happening this year, we decided to launch the first virtual event in response to the coronavirus lockdown. We would like to welcome you to Neotia Arts Trust’s new chapter — The India Story Continues… We will be hosting a Live web series of conversations, workshops, and performances from artists, designers, influencers, and many from all over India. Live events will be broadcasted every Saturday through the months of August, September, and October. It is complimentary and open to all and will be available on all our platforms — Youtube, Facebook, & our website. We are excited to continue creating, sharing, and learning with you all.",
                      "style": ""
                    })
                    return
                }
                reject(error);
            });
        });
    },

    setSignalBreakNotice: (context, payload) => {
        console.log("Payload -> ", payload)
        let data = {
            updatesignalmessage: payload.updatesignalmessage,
            seen_by_lco: payload.seen_by_lco
        }
        return new Promise((resolve, reject) => {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            fetch(context.getters.baseUrl + '/lco/v1/lco/' + payload.id_message, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json'},
                body: JSON.stringify(data)
            })
            .then(errorServeiceHandler)
            .then((response) => {
                return response.json()
            }).then((data) => {
                if (context.getters.getMode == "development") {
                    console ("Signal Update")
                    resolve({"updated_count":1})
                }
                else {
                    resolve(data)
                    console.log("Singal response->", data)
                }
            }).catch((error) => {
                if (context.getters.getMode == "development") {
                    resolve({"updated_count":1})
                    console.log("Singal Error->")
                } else {
                    reject(error);
                }
            });
        });
    },
};

export default {
    state, getters, mutations, actions
};



// WEBPACK FOOTER //
// ./src/store/modules/registrationModule.js